import { produce } from 'immer'

// Action Types
export const SET_AGENTIC_INSIGHTS = 'agenticInsights/setAgenticInsights'
export const SET_LOADING = 'agenticInsights/setLoading'
export const SET_ERROR = 'agenticInsights/setError'
export const SET_ACTIVATING_INSIGHT = 'agenticInsights/setActivatingInsight'
export const SET_LAUNCHING_INSIGHT = 'agenticInsights/setLaunchingInsight'
export const SET_INSIGHT_EXPERIMENT = 'agenticInsights/setInsightExperiment'
export const SET_CREATING_PROMPT_FOR_INSIGHT = 'agenticInsights/setCreatingPromptForInsight'
export const SET_INSIGHT_PROMPT_CREATED = 'agenticInsights/setInsightPromptCreated'
export const SET_INSIGHT_REVIEWED_USERS = 'agenticInsights/setInsightReviewedUsers'
export const SET_HAS_RUNS = 'agenticInsights/setHasRuns'

// Action Creators
export const setAgenticInsights = (payload) => ({ type: SET_AGENTIC_INSIGHTS, payload })
export const setLoading = (payload) => ({ type: SET_LOADING, payload })
export const setError = (payload) => ({ type: SET_ERROR, payload })
export const setActivatingInsight = (payload) => ({ type: SET_ACTIVATING_INSIGHT, payload })
export const setLaunchingInsight = (payload) => ({ type: SET_LAUNCHING_INSIGHT, payload })
export const setInsightExperiment = (payload) => ({ type: SET_INSIGHT_EXPERIMENT, payload })
export const setCreatingPromptForInsight = (payload) => ({
  type: SET_CREATING_PROMPT_FOR_INSIGHT,
  payload,
})
export const setInsightPromptCreated = (payload) => ({
  type: SET_INSIGHT_PROMPT_CREATED,
  payload,
})
export const setInsightReviewedUsers = (payload) => ({
  type: SET_INSIGHT_REVIEWED_USERS,
  payload,
})
export const setHasRuns = (payload) => ({ type: SET_HAS_RUNS, payload })

// State
export const initialState = {
  insights: [],
  loading: false,
  error: null,
  activatingInsightId: null,
  launchingInsightId: null,
  creatingPromptForInsightId: null,
  insightsWithPromptCreated: [],
  // Whether the org has ever had a run. null = not yet known; distinguishes
  // "we haven't run yet" from "we ran and found nothing" in the empty state.
  hasRuns: null,
}

export default function agenticInsightsReducer(state = initialState, action) {
  const { payload, type } = action

  return produce(state, (newState) => {
    switch (type) {
      case SET_AGENTIC_INSIGHTS:
        newState.insights = payload
        newState.error = null
        break
      case SET_LOADING:
        newState.loading = payload
        break
      case SET_ERROR:
        newState.error = payload
        break
      case SET_ACTIVATING_INSIGHT:
        newState.activatingInsightId = payload
        break
      case SET_LAUNCHING_INSIGHT:
        newState.launchingInsightId = payload
        break
      case SET_INSIGHT_EXPERIMENT: {
        const target = newState.insights.find((insight) => insight.id === payload.insightId)
        if (target) {
          target.experiment = { ...target.experiment, status: payload.experimentStatus }
        }
        break
      }
      case SET_CREATING_PROMPT_FOR_INSIGHT:
        newState.creatingPromptForInsightId = payload
        break
      case SET_INSIGHT_PROMPT_CREATED:
        if (!newState.insightsWithPromptCreated.includes(payload)) {
          newState.insightsWithPromptCreated.push(payload)
        }
        break
      case SET_INSIGHT_REVIEWED_USERS: {
        const target = newState.insights.find((insight) => insight.id === payload.insightId)
        if (target) {
          target.people = payload.people
        }
        break
      }
      case SET_HAS_RUNS:
        newState.hasRuns = payload
        break
      default:
        break
    }
  })
}
